import * as React from 'react';
import styled from 'styled-components/macro';
import { Power } from 'react-feather';
import { useHistory } from 'react-router-dom';
// import { useDispatch } from 'react-redux';

import {
  Tooltip,
  // Menu,
  // MenuItem,
  IconButton as MuiIconButton,
} from '@material-ui/core';

// import { signOut } from '../redux/actions/authActions';
import { useAuth } from '../contexts/auth';

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

function UserDropdown() {
  //const [anchorMenu, setAnchorMenu] = React.useState<any>(null);
  const { signOut } = useAuth();
  const history = useHistory();
  //const dispatch = useDispatch();

  // const toggleMenu = (event: React.SyntheticEvent) => {
  //   setAnchorMenu(event.currentTarget);
  // };

  // const closeMenu = () => {
  //   setAnchorMenu(null);
  // };

  const handleSignOut = async () => {
    await signOut();
    history.push('/auth/sign-in');
  };

  return (
    <React.Fragment>
      <Tooltip title="Sair">
        <IconButton
          //aria-owns={Boolean(anchorMenu) ? "menu-appbar" : undefined}
          aria-haspopup="true"
          onClick={handleSignOut}
          color="inherit"
        >
          <Power />
        </IconButton>
      </Tooltip>
      {/* <Menu
        id="menu-appbar"
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        onClose={closeMenu}
      >
        <MenuItem onClick={closeMenu}>Profile</MenuItem>
        <MenuItem onClick={handleSignOut}>Sign out</MenuItem>
      </Menu> */}
    </React.Fragment>
  );
}

export default UserDropdown;
